let dropdownMenu

$(window).on('show.bs.dropdown', function (e) {  
	dropdownMenu = $(e.target).find('.dropdown-menu')
	$('body').append(dropdownMenu.detach())

	const eOffset = $(e.target).offset()
	let css = {
		'display': 'block',
		'top': eOffset.top + $(e.target).outerHeight(),
	}

	if (dropdownMenu.hasClass('dropdown-menu-right')) {
		css['right'] = getRightOffset($(e.relatedTarget))
	} else {
		css['left'] = eOffset.left
	}

	dropdownMenu.css(css)
})
                                            
$(window).on('hide.bs.dropdown', function (e) {
	$(e.target).append(dropdownMenu.detach())
	dropdownMenu.hide()
})

function getRightOffset(element) {
	return ($(window).width() - (element.offset().left + element.outerWidth()))
}
